import { render } from "./gmAbnormalCallListNew.vue?vue&type=template&id=04e89c7c&scoped=true"
import script from "./gmAbnormalCallListNew.vue?vue&type=script&lang=js"
export * from "./gmAbnormalCallListNew.vue?vue&type=script&lang=js"

import "./gmAbnormalCallListNew.vue?vue&type=style&index=0&id=04e89c7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04e89c7c"

export default script